import {bufferInstance, jsonInstance,multipartFormData} from "./Api";

class UserDashboardService {

// New: GET /dashboard summary
getDashboardSummary(params) {
  return jsonInstance.get("/dashboard", { params });
}

exportData(data) {
  return jsonInstance.post("/campaign/calls/export-csv",data,
    { responseType: "blob" }
  );
}




}

export default new UserDashboardService();